import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { openAuthDialog } from "../../store/auth/authSlice";
import { Gift } from "lucide-react";

const MembershipsPageHeader = ({ itemVariants, trialEligible }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleLogin = () => {
    dispatch(
      openAuthDialog({
        showLoginFirstOrOnSuccess: true,
        onSuccessfulAuth: () => navigate("/list-inventory", { replace: true }),
      }),
    );
  };

  const handleSignUp = () => {
    dispatch(
      openAuthDialog({
        showLoginFirstOrOnSuccess: false,
        onSuccessfulAuth: (role) => {
          if (role === "seller") navigate("/list-inventory", { replace: true });
        },
        defaultTabOverride: "signup",
      }),
    );
  };

  return (
    <motion.div
      className="text-center pt-10 px-4 md:px-0"
      variants={itemVariants}
    >
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4 bg-gradient-to-r from-primary via-purple-500 to-accent text-transparent bg-clip-text">
        Grow Your Business with PartsLokator
      </h1>
      <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto mb-8">
        Unlock powerful tools to list your inventory, connect with a vast
        network of buyers, and accelerate your auto parts sales. Choose the plan
        that fits your business needs.
      </p>

      {trialEligible && (
        <div className="relative bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 border border-primary/30 p-5 rounded-xl max-w-3xl mx-auto mb-8 shadow-sm">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/15 text-primary flex-shrink-0">
              <Gift className="w-5 h-5" />
            </div>
            <div className="text-center sm:text-left">
              <p className="font-bold text-foreground text-base sm:text-lg">
                🎉 Try Pro or Premium free for 30 days — no credit card required
              </p>
              <p className="text-sm text-muted-foreground mt-0.5">
                Start selling immediately. Cancel anytime before your trial ends
                and you won't be charged.
              </p>
            </div>
          </div>
        </div>
      )}

      {!isAuthenticated && (
        <p className="text-md text-foreground bg-secondary/30 p-3 rounded-lg inline-block">
          Please{" "}
          <button
            onClick={handleLogin}
            className="text-primary font-semibold underline hover:text-primary/80 transition-colors"
          >
            Log In
          </button>{" "}
          or{" "}
          <button
            onClick={handleSignUp}
            className="text-primary font-semibold underline hover:text-primary/80 transition-colors"
          >
            Sign Up
          </button>{" "}
          to select a plan and view detailed pricing.
        </p>
      )}
    </motion.div>
  );
};

export default React.memo(MembershipsPageHeader);
